import { Injectable } from '@angular/core';
import { coalesce } from '@asamco/utils';
import { L10nTranslationService } from 'angular-l10n';
import { Subject } from 'rxjs';

const appLoadingClass = 'app-loading';
const defaultShowDelay = 150;
const minVisibleTime = 1000;

@Injectable({
	providedIn: 'root',
})
export class AppService {
	private get isAppLoading(): boolean {
		return document.body.classList.contains(appLoadingClass);
	}

	private loadingStartDate: number = 0;
	private appLoadingMessage: Subject<string> = new Subject<string>();
	appLoadingMessage$ = this.appLoadingMessage.asObservable();

	/**
	 * Constructor
	 */
	constructor(private ts: L10nTranslationService) {}

	beginLoading(args?: { message?: string; showDelay?: number }) {
		const settings = Object.assign({}, args, {
			visible: true,
			showDelay: defaultShowDelay,
		});

		this.appLoadingMessage.next(coalesce(settings.message, this.ts.translate('APP.PAGE_LOADING_INDICATOR.DEFAULT_LOADING_MESSAGE')));
		document.body.classList.add(appLoadingClass);
		this.loadingStartDate = Date.now();
	}

	endLoading(withMinVisbibleTime = true) {
		const settings = Object.assign(
			{},
			{
				visible: false,
				minVisibleTime: minVisibleTime,
			}
		);

		if (withMinVisbibleTime) {
			const visibleTime = this.loadingStartDate > 0 ? Date.now() - this.loadingStartDate : 0;
			const endDelay = Math.max(0, settings.minVisibleTime - visibleTime);
			setTimeout(() => {
				document.body.classList.remove(appLoadingClass);
			}, endDelay);
		} else {
			document.body.classList.remove(appLoadingClass);
		}
	}
}
